import React from 'react';
import { vehicleCategories } from '../data/vehicleData.js';
import SafeIcon from '../common/SafeIcon.jsx';
import * as FiIcons from 'react-icons/fi';

const { FiChevronDown } = FiIcons;

const VehicleSelector = ({ selectedVehicle, onVehicleChange }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800">Select Vehicle</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(vehicleCategories).map(([categoryId, category]) => (
          <div key={categoryId} className="space-y-2">
            <h4 className="font-medium text-gray-700 text-sm uppercase tracking-wide">
              {category.name}
            </h4>
            <div className="relative">
              <select
                value={selectedVehicle === '' ? '' : (category.models.includes(selectedVehicle) ? selectedVehicle : '')}
                onChange={(e) => onVehicleChange(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg appearance-none bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              >
                <option value="">Select {category.name}</option>
                {category.models.map((model) => (
                  <option key={model} value={model}>
                    {model}
                  </option>
                ))}
              </select>
              <SafeIcon 
                icon={FiChevronDown} 
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
              />
            </div>
          </div>
        ))}
      </div>

      {selectedVehicle && (
        <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="text-blue-800 font-medium">Selected: {selectedVehicle}</p>
        </div>
      )}
    </div>
  );
};

export default VehicleSelector;